.cabecera { flex: 1; width: 100%; display: flex; align-items: flex-start; justify-content: space-between; gap: var(--s-5); }
.titulo { display: flex; flex-direction: column; gap: var(--s-2); min-width: 0; }
.botonesCabecera { display: flex; gap: var(--s-3); flex-shrink: 0; }

.fase { display: flex; flex-direction: column; gap: var(--s-4); }
.progreso { display: flex; gap: 3px; }
.progreso span { flex: 1; height: 5px; border-radius: var(--r-full); background: var(--gray-200); }
.progreso span[data-hecha="true"] { background: var(--accent-500); }
.progreso[data-cortado="true"] span { background: var(--red-200); }
.actual { color: var(--accent-700); }
.no { color: var(--red-700); }

.seccion { display: flex; flex-direction: column; gap: var(--s-7); }
.chat { display: flex; flex-direction: column; gap: var(--s-5); padding: var(--s-6); border-radius: var(--r-lg); background: var(--gray-50); }
.burbuja { display: flex; flex-direction: column; gap: var(--s-2); max-width: 85%; align-self: flex-start; padding: var(--s-4) var(--s-5); border-radius: 12px 12px 12px 4px; background: var(--surface-card); border: 1px solid var(--border-hair); }
.burbuja[data-nuestra="true"] { align-self: flex-end; border-radius: 12px 12px 4px 12px; background: var(--accent-50); border-color: var(--accent-100); }
.etiquetaBurbuja { font-size: var(--fs-3xs); font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; color: var(--accent-700); }
.burbuja[data-nuestra="false"] .etiquetaBurbuja { color: var(--text-muted); }
.textoBurbuja { font-size: var(--fs-sm); line-height: 20px; color: var(--text-strong); white-space: pre-wrap; }
.hora { font-size: var(--fs-3xs); color: var(--text-muted); }
.chatwoot { align-self: flex-start; }

.nota { display: flex; flex-direction: column; gap: var(--s-4); }
.guardar { display: flex; justify-content: flex-end; gap: var(--s-4); }
.ficha { align-self: flex-start; }
.deshacer { display: flex; align-items: center; justify-content: space-between; gap: var(--s-5); padding: var(--s-5) var(--s-6); border-radius: var(--r-md); background: var(--gray-50); }
